
export const row1Data = [
    {
        label: 'People',
        value: '12,345',
        detailLink: '/viewPeople',
        updateDt: '03-11-2018',
    },
    {
        label: 'Collection',
        value: '7,65,432.00',
        
        detailLink: '/viewPeople',
        updateDt: '03-11-2018',
    },
    {
        label: 'Sold Items',
        value: '9,876',
        
        detailLink: '/viewPeople',
        updateDt: '03-11-2018',
    },
    {
        label: 'Due Payment',
        value: '1,23,456.00',
       
        detailLink: '/viewPeople',
        updateDt: '03-11-2018',
    },
]
